import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { CreateClientMarketMutationRequest, CreateClientMarketMutationResponse, CreateClientMarketPathParams, CreateClientMarket400 } from "../types/CreateClientMarket";
import type { UseMutationOptions } from "@tanstack/react-query";

 type CreateClientMarketClient = typeof client<CreateClientMarketMutationResponse, CreateClientMarket400, CreateClientMarketMutationRequest>;
type CreateClientMarket = {
    data: CreateClientMarketMutationResponse;
    error: CreateClientMarket400;
    request: CreateClientMarketMutationRequest;
    pathParams: CreateClientMarketPathParams;
    queryParams: never;
    headerParams: never;
    response: CreateClientMarketMutationResponse;
    client: {
        parameters: Partial<Parameters<CreateClientMarketClient>[0]>;
        return: Awaited<ReturnType<CreateClientMarketClient>>;
    };
};
/**
 * @description Creates a new market for a given client
 * @summary Create
 * @link /api/clients/:clientCode/markets
 */
export function useCreateClientMarket(clientCode: CreateClientMarketPathParams["clientCode"], options: {
    mutation?: UseMutationOptions<CreateClientMarket["response"], CreateClientMarket["error"], CreateClientMarket["request"]>;
    client?: CreateClientMarket["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<CreateClientMarket["data"], CreateClientMarket["error"], CreateClientMarket["request"]>({
                method: "post",
                url: `/api/clients/${clientCode}/markets`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}